import {DBStatus} from "./common.model";
import {JobBonus} from "./employee.model";

import {GeoFenceEmployeePosition} from "../home/geo/model/GeoFenceEmployeePosition";
import {JSonSerializer} from "./JSonSerializer";
import {EnterpriseCostDistributionConfig} from "../home/costDistribution/model/EnterpriseCostDistributionConfig";
import {CostDistributionType} from "../home/costDistribution/model/CostDistributionType";
import {Utils} from "./Utils";

export class EmployeeJob {
  employeeId: string;
  // status = DBStatus.ACTIVE;

  employeePosteStatus = DBStatus.ACTIVE;
  echelon: number;
  bonus: number;
  bonusInPercent:number;
  unitId: string;
  note: string;
  defaultJob: boolean;
  exportDivision: string;
  exportService: string;
  exportDepartment: string;
  exportSubDepartment: string;
  jobId: string;
  jobLabel: string; // EmployePoste
  status: string;
  bg: number;
  bonusId1: number;
  bonusId2: number;
  bonusId3: number;
  bonusId4: number;
  bonusId5: number;
  bonusId6: number;
  bonusId7: number;
  bonusId8: number;
  bonusId9: number;
  bonusId10: number;
  bonusId11:number;
  bonusId12:number;
  bonusId13:number;
  bonusId14:number;
  bonusId15:number;
  bonusId16:number;
  bonusId17:number;
  bonusId18:number;
  bonusId19:number;
  bonusId20:number;
  // NG
  unitDescription: string;
  // jobDescription: string;
  divisionId: string;
  divisionDescription: string;
  ccqJob = false;
  ccqSecteur:string;
  ccqAnnexe: string;
  ccqMetier: string;
  ccqRegion: string;
  ccqApprenti: string;
  ccqLocal: string;
  segment1: string;
  segment2: string;
  segment3: string;
  segment4: string;
  segment5: string;
  segment6: string;
  initialSeniorityInMin: number;

  geoFenceEmployeePositions = new Array<GeoFenceEmployeePosition>();

  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('geoFenceEmployeePositions' === propertyName) {
      for (const bean of <GeoFenceEmployeePosition[]>data) {
        const tmp = new GeoFenceEmployeePosition();
        serializer.deserialize(bean, tmp);
        this.geoFenceEmployeePositions.push(tmp);
      }
    }
  }

    _createSpecialElement(propertyName: string, data: any) {
    if ('employeePosteStatus' === propertyName) {
      this.employeePosteStatus = DBStatus.retrieveFromCode(data);
      return true;
    }
    return false;
  }

  public get isActive(): boolean{
    if (DBStatus.ACTIVE===this.employeePosteStatus){
      return true;
    }
    return false;
  }


  public resetAllBonus(){
    this.bonusId1 = -1;
    this.bonusId2 = -1;
    this.bonusId3 = -1;
    this.bonusId4 = -1;
    this.bonusId5 = -1;
    this.bonusId6 = -1;
    this.bonusId7 = -1;
    this.bonusId8 = -1;
    this.bonusId9 = -1;
    this.bonusId10 = -1;
    this.bonusId11 = -1;
    this.bonusId12 = -1;
    this.bonusId13 = -1;
    this.bonusId14 = -1;
    this.bonusId15 = -1;
    this.bonusId16 = -1;
    this.bonusId17 = -1;
    this.bonusId18 = -1;
    this.bonusId19 = -1;
    this.bonusId20 = -1;

  }


  public addDefaultBonus(toAdd: JobBonus): boolean{
    console.log('Trying Default Bonus: ',toAdd);
    if (!Utils.isNullOrUndefined(toAdd.isDefault)){
      if (toAdd.isDefault) {
        console.log('Checking if bonus is already present');

        switch (toAdd.id) {
          case this.bonusId1:
          case this.bonusId2:
          case this.bonusId3:
          case this.bonusId4:
            console.log('Default Bonus already present');
            return false;
        }

        if (Utils.isNullOrUndefined(this.bonusId1) || this.bonusId1<=0){
          this.bonusId1 = toAdd.id;
          return true;
        }else if (Utils.isNullOrUndefined(this.bonusId2) || this.bonusId2<=0){
          this.bonusId2 = toAdd.id;
          return true;
        }else if (Utils.isNullOrUndefined(this.bonusId3) || this.bonusId3<=0){
          this.bonusId3 = toAdd.id;
          return true;
        }else if (Utils.isNullOrUndefined(this.bonusId4) || this.bonusId4<=0){
          this.bonusId4 = toAdd.id;
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Used only if required. Aka enterprise uses segments BUT nbSegments==0
   */
  public get nonSegmentedJobNumber(){
    let nonSegmentedJobNumber = this._addSegment(this.segment1,'');
    nonSegmentedJobNumber = this._addSegment(this.segment2,nonSegmentedJobNumber);
    nonSegmentedJobNumber = this._addSegment(this.segment3,nonSegmentedJobNumber);
    nonSegmentedJobNumber = this._addSegment(this.segment4,nonSegmentedJobNumber);
    nonSegmentedJobNumber = this._addSegment(this.segment5,nonSegmentedJobNumber);
    nonSegmentedJobNumber = this._addSegment(this.segment6,nonSegmentedJobNumber);
    return nonSegmentedJobNumber;
  }

  private _addSegment(segment: string,nonSegmentedJobNumber: string): string{
    if (!Utils.isNullOrUndefined(segment) && segment.length>0){
      if (nonSegmentedJobNumber.length>0){
        nonSegmentedJobNumber += '.';
      }
      nonSegmentedJobNumber += segment;
    }
    return nonSegmentedJobNumber;
  }

  public clearSegments(){
    this.segment1 = '';
    this.segment2 = '';
    this.segment3 = '';
    this.segment4 = '';
    this.segment5 = '';
    this.segment6 = '';
  }

  public populateSegments(configs: EnterpriseCostDistributionConfig[]){
    if (configs){
      this.clearSegments();
      for (const config of configs){
        if (CostDistributionType.SEGMENT1 === config.costDistributionType){
          this.segment1 = config.value;
        }
        if (CostDistributionType.SEGMENT2=== config.costDistributionType){
          this.segment2 = config.value;
        }
        if (CostDistributionType.SEGMENT3 === config.costDistributionType){
          this.segment3 = config.value;
        }
        if (CostDistributionType.SEGMENT4 === config.costDistributionType){
          this.segment4 = config.value;
        }
        if (CostDistributionType.SEGMENT5 === config.costDistributionType){
          this.segment5 = config.value;
        }
        if (CostDistributionType.SEGMENT6 === config.costDistributionType){
          this.segment6 = config.value;
        }
      }
    }
  }


}
